import React, { useEffect, useState } from 'react'
import './PrivacyPolicy.css'
import { Link } from "react-router-dom"

const PrivacyPolicy = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
    const [text, setText] = useState("");

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768 && !isSmallScreen) {
                setIsSmallScreen(true);
            } else if (window.innerWidth >= 768 && isSmallScreen) {
                setIsSmallScreen(false);
            };
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [isSmallScreen]);
  return (
    <div className='privacy-policy'>
        <div className="privacy-policy-container">
            <div className="privacy-policy-header">
                <div className="privacy-policy-badge">
                     <p>Privacy Policy</p>
                </div>
                <h2>SendCheap Respects Your Privacy</h2>
            </div>
            <div className="privacy-policy-content">
              <div className="policy-content">
                <h3>Introduction</h3>
                <p
                  dangerouslySetInnerHTML={{
                    __html: isSmallScreen ? (
                      `<span>SendCheap</span> is committed to protecting the privacy and 
                      security of your personal information. This Privacy Policy outlines
                      how we collect, use, disclose,  and protect your information when  you use our services`
                    ) : (
                      `<span>SendCheap</span> is committed to protecting the privacy and 
                      security of your personal information. This Privacy Policy outlines
                      how we <br /> collect, use, disclose,  and protect your information when  you use our services`
                    )  
                  }}
                  />
              </div> 
              <div className="policy-content">
                <h3>Information We collect</h3>
                <p>
                  We may collect the followiing information from you:
                </p>
                <ul>
                  <li>Personal Information: Name, email address, phone number, and other contact details.</li>
                  <li>Financial Information: Payment card details, bank account information, and transaction history.</li>
                  <li>Device Information: Information about the device you use to access our services, such as IP address and device ID.</li>
                  <li>Usage Data: Information about how you use our services, such as the features you access and the transactions you make.</li>
                </ul>
              </div>    
              <div className="policy-content">
                <h3>How we use your information</h3>
                <p>We use your information for the following purposes:</p>
                <ul>
                  <li>To provide and improve our services.</li>
                  <li>To process payments and prevent fraud.</li>
                  <li>To communicate with you about your account and our services.  </li>
                  <li>To comply with legal and regulatory requirements.</li>
                </ul>
              </div> 
              <div className="policy-content">
                <h3>Sharing Your Information</h3>
                <p>We may share your information with:</p>
                <ul>
                  <li
                      dangerouslySetInnerHTML={{
                      __html: isSmallScreen ? (
                        `Trusted third-party service providers: We may share your information with third-party service providers 
                        who help us operate our business and provide our services.`
                      ) : (
                        `Trusted third-party service providers: We may share your information with third-party service providers 
                        who help us operate our business and <br /> provide our services.`
                      )
                    }}
                    />
                  <li>1. www.xzist.com</li>
                  <li>www.xzist.com</li>
                  <li>Law enforcement: We may disclose your information to law enforcement if required by law or to protect our rights.</li>
                </ul>
              </div>    
              <div className="policy-content">
                <h3>Data Security</h3>
                <p
                    dangerouslySetInnerHTML={{
                     __html: isSmallScreen ? (                    
                          `We implement reasonable security measures to protect your information from unauthorized access, disclosure, alteration,
                           and destruction. However, no method of transmission over the internet or electronic storage is completely secure.`
                     ) : (
                      `We implement reasonable security measures to protect your information from unauthorized access, disclosure, alteration,
                      and destruction. <br/> However, no method of transmission over the internet or electronic storage is completely secure.`
                     ) 
                   }}      
                />
              </div>    
              <div className="policy-content">
                <h3>Your Rights</h3>
                <p
                    dangerouslySetInnerHTML={{
                      __html: isSmallScreen ? (                    
                            `You have the right to access, correct, or delete your personal information. You can exercise these rights
                             by contacting us at <a href="mailto:contact@sendcheap.ng">contact@sendcheap.ng </a>`
                      ) : (
                        `You have the right to access, correct, or delete your personal information. You can exercise these rights
                        by contacting us at <br /><a href="mailto:contact@sendcheap.ng">contact@sendcheap.ng </a>`
                      )
                    }}
                />
              </div>    
              <div className="policy-content">
                <h3>Changes To This Policy</h3>
                <p
                    dangerouslySetInnerHTML={{
                      __html: isSmallScreen ? (                     
                            `We may update this Privacy Policy from time to time. We will notify you of any significant changes by posting
                             the new <br /> Privacy Policy on our website.`
                      ) : (
                        `We may update this Privacy Policy from time to time. We will notify you of any significant changes by posting
                        the new <br /> Privacy Policy on our website.`
                      )
                    }}       
                />
              </div>    
              <div className="policy-content">
                <h3>Contact Us</h3>
                <p>
                  If you have any questions about this Privacy Policy, contact us.  
                </p>
              </div> 
              <div className="privacy-policy-btn">
                <Link to='contact'>
                  <button className='policy-btn-1'>Contact Us</button>
                </Link>  
                <button className="policy-btn-2">Open an Account</button>
              </div>   
            </div>
        </div>
    </div>
  )
}

export default PrivacyPolicy
